import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import axios from "axios";
import { ModalTipoDeRentas } from "./modalTipoRenta";
import { Toasts } from "../../toasts";
//UI
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";

const headCells = [
  {
    id: "",
    label: "CODIGO",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "DESCRIPCION",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "OPCIONES",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

export function TablaTiposRentas(props) {
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [records, setRecords] = useState([]);
  const [rentas, setRentas] = useState();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const permiso = JSON.parse(localStorage.getItem("acctiporenta"));
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const handleSearch2 = (e) => {
    let target = e.target;
    if ((target.name = "Search")) {
      target.value = target.value.toUpperCase();
      setFilterFn({
        fn: (items) => {
          if (target.value === "") {
            return items;
          } else {
            return items.filter((x) => {
              if (
                x.idtiporentas
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                x.descripcion.toLowerCase().includes(target.value.toLowerCase())
              ) {
                return x;
              }
            });
          }
        },
      });
    }
  };
  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "tiporentas";
    let orden = "idtiporentas";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarRegistro = (idtiporentas) => {
    let campos = "*";
    let nomtab = "tiporentas";
    let nomid = "idtiporentas";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idtiporentas}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idtiporentas > 0) {
            setRentas(response.data);
            setActivate(false);
            setMostrar5(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const consultarTipoRenta = (ope, id, per) => (event) => {
    event.preventDefault();
    if (per.toString() === "1") {
      if (ope === 1) {
        setMostrar5(true);
        setOperacion(1);
      } else if (ope === 4) {
        setOperacion(4);
        seleccionarRegistro(id);
      } else if (ope === 2) {
        setOperacion(2);
        seleccionarRegistro(id);
      } else if (ope === 3) {
        setOperacion(3);
        seleccionarRegistro(id);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          ope === 1
            ? "No posee permiso para Registrar"
            : ope === 2
            ? "No posee permiso para Editar"
            : ope === 3
            ? "No posee permiso para Eliminar"
            : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };
  const cerrarModalActualizar = () => {
    setMostrar5(false);
    blanquearCampos();
  };
  const blanquearCampos = () => {
    setActivate(false);
    setOperacion(0);
    setRentas();
  };
  useEffect(() => {
    seleccionarRegistros();
  }, []);
  const cerrar = () => {
    props.setTabla(0);
  };
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };
  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Gestion Tipos de Rentas Municipales</h3>
        <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <SearchInput
            placeholder="Buscar"
            onChange={handleSearch2}
            name="Search"
          />
        </div>
        <div className="col-auto m-0 p-0">
          <PrimaryButton
            icon="fa-plus m-0"
            onClick={consultarTipoRenta(
              1,
              "",
              permiso.toString().substring(1, 2)
            )}
            disabled={permiso.toString().substring(1, 2) !== "1"}
          />
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idtiporentas} style={{ padding: "0" }}>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    {item.idtiporentas}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "300px",
                    }}
                  >
                    {item.descripcion}
                  </td>
                  <td
                    className="py-1"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                      padding: 0,
                    }}
                  >
                    <button
                      onClick={consultarTipoRenta(
                        4,
                        item.idtiporentas,
                        permiso.toString().substring(0, 1)
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarTipoRenta(
                        2,
                        item.idtiporentas,
                        permiso.toString().substring(2, 3)
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarTipoRenta(
                        3,
                        item.idtiporentas,
                        permiso.toString().substring(3, 4)
                      )}
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ModalTipoDeRentas
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
        rentas={rentas}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}
